const removeUniqueValues = array => {
    const map = new Map();
    array.forEach(a => map.set(a, (map.get(a) || 0) + 1));
    return [...new Set(array.filter(a => map.get(a) > 1))];
};

module.exports = {
    removeUniqueValues
};
